import type { RootState } from '/business/shared/state/store';
/*
 * Get the selected dashboard application state
 */

export default (state: RootState) => state.applications?.dashboardApplicationsState;
